import * as React from 'react'
import Select from 'react-select-next'

export interface ISelectOption {
  label: string
  value: any
}

interface ICommonProps {
  id?: string
  className?: string
  placeholder?: string
  options: ISelectOption[]
  isClearable?: boolean
  isDisabled?: boolean
  isLoading?: boolean
  style?: React.CSSProperties
  onInputChange?: (inputValue: string) => void
  isOptionDisabled?: (option: ISelectOption | null) => void
}

interface ISingleSelectProps extends ICommonProps {
  initialValue?: string | number | null
  onChange: (option: ISelectOption | null) => void
}

interface MultiSelectProps extends ICommonProps {
  initialValues?: Array<string | number | null>
  onChange: (option: ISelectOption[] | null) => void
}

export const ReactSingleSelect = (props: ISingleSelectProps) => {
  const {
    id,
    initialValue,
    className,
    options,
    onChange,
    isClearable,
    isDisabled,
    placeholder,
    isLoading,
    onInputChange,
    style,
    isOptionDisabled,
  } = props
  const value =
    initialValue && options.find((option) => String(initialValue) === String(option.value))

  return (
    <Select
      id={id}
      value={value}
      className={className}
      options={options}
      placeholder={placeholder}
      isClearable={isClearable}
      isMulti={false}
      isDisabled={isDisabled}
      isLoading={isLoading}
      onInputChange={onInputChange}
      onChange={onChange}
      isOptionDisabled={isOptionDisabled}
      style={style}
    />
  )
}

export const ReactMultiSelect = (props: MultiSelectProps) => {
  const {
    id,
    initialValues,
    className,
    options,
    onChange,
    isClearable,
    isDisabled,
    placeholder,
    isLoading,
    onInputChange,
    style,
    isOptionDisabled,
  } = props
  const values =
    initialValues &&
    initialValues.length > 0 &&
    options.filter((option) => {
      // initialValues can be an array containing string or number.
      // Set it to string before using `includes`
      return initialValues.map(String).includes(String(option.value))
    })

  return (
    <Select
      id={id}
      value={values}
      className={className}
      options={options}
      placeholder={placeholder}
      isClearable={isClearable}
      isMulti={true}
      isDisabled={isDisabled}
      isLoading={isLoading}
      onInputChange={onInputChange}
      onChange={onChange}
      isOptionDisabled={isOptionDisabled}
      style={style}
    />
  )
}
